(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuance-wish-trigger')) {
    customElements.define(
      'nuance-wish-trigger',
      class extends HTMLElement {
        connectedCallback() {
          const link = this.querySelector('a');
          if (!link) return;
          link.addEventListener('click', (event) => {
            const drawer = document.getElementById('wishlist-drawer');
            if (!drawer || typeof drawer.toggle !== 'function') return;
            event.preventDefault();
            drawer.querySelector('nuance-wish-drawer')?.refresh();
            drawer.toggle();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuance-cart-upsell-js"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuance-cart-upsell')) {
    customElements.define(
      'nuance-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.index = 0;
          this.sync();

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-ncu-prev]')) {
              this.go(-1);
              return;
            }
            if (event.target.closest('[data-ncu-next]')) {
              this.go(1);
              return;
            }
            const button = event.target.closest('[data-ncu-add]');
            if (!button) return;
            event.preventDefault();
            this.add(button);
          });

          this.observer = new MutationObserver(() => this.sync(true));
          this.observer.observe(this, { childList: true, subtree: true });

          this.onResize = () => this.place(true);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          if (this.onResize) window.removeEventListener('resize', this.onResize);
          if (this.observer) this.observer.disconnect();
        }

        sync(instant) {
          const track = this.querySelector('[data-ncu-track]');
          if (!track) return;
          this.track = track;
          const count = track.children.length;
          if (!count) return;
          if (this.index > count - 1) this.index = 0;

          const prev = this.querySelector('[data-ncu-prev]');
          const next = this.querySelector('[data-ncu-next]');
          if (prev) prev.hidden = count < 2;
          if (next) next.hidden = count < 2;

          if (track.style.transform !== 'translateX(' + -this.index * 100 + '%)') this.place(instant);
        }

        place(instant) {
          if (!this.track) return;
          if (instant) this.track.setAttribute('data-ncu-instant', '');
          this.track.style.transform = 'translateX(' + -this.index * 100 + '%)';
          if (instant) {
            void this.track.offsetWidth;
            this.track.removeAttribute('data-ncu-instant');
          }
        }

        go(direction) {
          const track = this.querySelector('[data-ncu-track]');
          if (!track) return;
          this.track = track;
          const count = track.children.length;
          if (count < 2) return;
          const nextIndex = (this.index + direction + count) % count;
          const wrapping = Math.abs(nextIndex - this.index) > 1;
          this.index = nextIndex;
          this.place(wrapping);
        }

        async add(button) {
          const card = button.closest('.ncu__card');
          const select = card?.querySelector('[data-ncu-size]');
          const status = card?.querySelector('[data-ncu-status]');
          if (!card || !select || card.classList.contains('is-adding')) return;

          const setStatus = (text) => {
            if (status) status.textContent = text || '';
          };

          const variantId = select.value;
          if (!variantId) {
            setStatus('Choose a size');
            return;
          }

          card.classList.add('is-adding');
          setStatus('Adding...');

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const routes = (window.Theme && window.Theme.routes) || {};
          const addUrl = (routes.cart_add_url || root + 'cart/add').replace(/\\.js$/, '');
          const cartUrl = (routes.cart_url || root + 'cart').replace(/\\.js$/, '');

          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          let events = null;
          let deferred = null;
          try {
            events = await import('@shopify/events');
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'cart',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
          } catch (e) {
            events = null;
            deferred = null;
          }

          const getCart = () =>
            fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

          try {
            const response = await fetch(addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const data = await response.json();

            if (data.status) {
              if (deferred) {
                getCart()
                  .then((cart) =>
                    deferred.resolve({
                      cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                      detail: {
                        didError: true,
                        items: cart.items,
                        source: 'nuance-cart-upsell',
                        itemCount: 1,
                        productId: button.dataset.productId,
                      },
                    })
                  )
                  .catch((err) => deferred.reject(err));
              }
              throw new Error(data.description || data.message || 'Could not add to bag');
            }

            if (deferred) {
              const cart = await getCart();
              deferred.resolve({
                cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items,
                  source: 'nuance-cart-upsell',
                  itemCount: 1,
                  productId: button.dataset.productId,
                  sections: data.sections,
                  didError: false,
                },
              });
            }

            setStatus('Added');
          } catch (error) {
            setStatus(error && error.message ? error.message : 'Could not add to bag');
          } finally {
            card.classList.remove('is-adding');
            clearTimeout(this.statusTimer);
            this.statusTimer = setTimeout(() => setStatus(''), 2500);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuance-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuance-cart-upsell')) {
    customElements.define(
      'nuance-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.index = 0;
          this.sync();

          /* Every click is delegated to the element itself rather than bound to the buttons
             inside it. The theme rebuilds the drawer's markup on each cart change, so a
             listener attached to an arrow would be thrown away together with that arrow, and
             the carousel would stop responding for the rest of the session. */
          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-ncu-prev]')) {
              this.go(-1);
              return;
            }
            if (event.target.closest('[data-ncu-next]')) {
              this.go(1);
              return;
            }
            const button = event.target.closest('[data-ncu-add]');
            if (!button) return;
            event.preventDefault();
            this.add(button);
          });

          /* The same rebuild wipes the strip's transform, and it can change how many cards
             are offered, because the product just added drops out of the list. Left alone,
             the component keeps an index that no longer matches what is on screen: the strip
             shows the first card while the component believes it is on the third, so the next
             tap jumps several cards at once, or lands past the end on nothing at all. That is
             what made the carousel look dead right after an add. */
          this.observer = new MutationObserver(() => this.sync(true));
          this.observer.observe(this, { childList: true, subtree: true });

          this.onResize = () => this.place(true);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          if (this.onResize) window.removeEventListener('resize', this.onResize);
          if (this.observer) this.observer.disconnect();
        }

        /* Reads the strip back from the DOM. Nothing about it is kept across a refresh: the
           track, the number of cards and the arrows are looked up every time. */
        sync(instant) {
          const track = this.querySelector('[data-ncu-track]');
          if (!track) return;
          this.track = track;
          const count = track.children.length;
          if (!count) return;
          if (this.index > count - 1) this.index = 0;

          // One card only: the arrows would have nothing to do
          const prev = this.querySelector('[data-ncu-prev]');
          const next = this.querySelector('[data-ncu-next]');
          if (prev) prev.hidden = count < 2;
          if (next) next.hidden = count < 2;

          if (track.style.transform !== 'translateX(' + -this.index * 100 + '%)') this.place(instant);
        }

        place(instant) {
          if (!this.track) return;
          if (instant) this.track.setAttribute('data-ncu-instant', '');
          this.track.style.transform = 'translateX(' + -this.index * 100 + '%)';
          if (instant) {
            void this.track.offsetWidth;
            this.track.removeAttribute('data-ncu-instant');
          }
        }

        // Wraps round in both directions, with no visible rewind across the whole strip
        go(direction) {
          const track = this.querySelector('[data-ncu-track]');
          if (!track) return;
          this.track = track;
          const count = track.children.length;
          if (count < 2) return;
          const nextIndex = (this.index + direction + count) % count;
          const wrapping = Math.abs(nextIndex - this.index) > 1;
          this.index = nextIndex;
          this.place(wrapping);
        }

        async add(button) {
          const card = button.closest('.ncu__card');
          const select = card?.querySelector('[data-ncu-size]');
          const status = card?.querySelector('[data-ncu-status]');
          if (!card || !select || card.classList.contains('is-adding')) return;

          const setStatus = (text) => {
            if (status) status.textContent = text || '';
          };

          /* An empty value means every size is sold out, or the picker has not settled yet.
             Returning in silence made the button look broken; say why nothing happened. */
          const variantId = select.value;
          if (!variantId) {
            setStatus('Choose a size');
            return;
          }

          card.classList.add('is-adding');
          setStatus('Adding…');

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const routes = (window.Theme && window.Theme.routes) || {};
          const addUrl = (routes.cart_add_url || root + 'cart/add').replace(/\\.js$/, '');
          const cartUrl = (routes.cart_url || root + 'cart').replace(/\\.js$/, '');

          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          // Tell the theme a line is being added so the drawer and the bubble refresh
          let events = null;
          let deferred = null;
          try {
            events = await import('@shopify/events');
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'cart',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
          } catch (e) {
            events = null;
            deferred = null;
          }

          const getCart = () =>
            fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

          try {
            const response = await fetch(addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const data = await response.json();

            if (data.status) {
              if (deferred) {
                getCart()
                  .then((cart) =>
                    deferred.resolve({
                      cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                      detail: {
                        didError: true,
                        items: cart.items,
                        source: 'nuance-cart-upsell',
                        itemCount: 1,
                        productId: button.dataset.productId,
                      },
                    })
                  )
                  .catch((err) => deferred.reject(err));
              }
              throw new Error(data.description || data.message || 'Could not add to bag');
            }

            if (deferred) {
              const cart = await getCart();
              deferred.resolve({
                cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items,
                  source: 'nuance-cart-upsell',
                  itemCount: 1,
                  productId: button.dataset.productId,
                  sections: data.sections,
                  didError: false,
                },
              });
            } else {
              window.location.reload();
              return;
            }

            setStatus('Added');
          } catch (error) {
            setStatus(error && error.message ? error.message : 'Could not add to bag');
          } finally {
            card.classList.remove('is-adding');
            clearTimeout(this.statusTimer);
            this.statusTimer = setTimeout(() => setStatus(''), 2500);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuance-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'nuance:wishlist';

    const readList = () => {
      try {
        const list = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };

    const writeList = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('nuance:wishlist-change', { detail: { list } }));
    };

    if (customElements.get('nuance-card')) return;

    customElements.define(
      'nuance-card',
      class extends HTMLElement {
        connectedCallback() {
          this.handle = this.dataset.handle;
          this.productTitle = this.dataset.title || '';
          this.wish = this.querySelector('[data-wish]');
          this.status = this.querySelector('[data-status]');

          this.syncWish = () => {
            if (!this.wish) return;
            const saved = readList().includes(this.handle);
            this.wish.setAttribute('aria-pressed', saved ? 'true' : 'false');
            this.wish.setAttribute('aria-label', saved ? 'Remove ' + this.productTitle + ' from wishlist' : 'Add ' + this.productTitle + ' to wishlist');
          };
          this.syncWish();
          document.addEventListener('nuance:wishlist-change', this.syncWish);

          this.wish?.addEventListener('click', (event) => {
            event.preventDefault();
            const list = readList();
            const index = list.indexOf(this.handle);
            if (index === -1) {
              list.push(this.handle);
              this.wish.classList.remove('is-popping');
              void this.wish.offsetWidth;
              this.wish.classList.add('is-popping');
            } else {
              list.splice(index, 1);
            }
            writeList(list);
          });

          this.querySelectorAll('[data-variant-id]').forEach((button) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.add(button.dataset.variantId);
            });
          });
        }

        disconnectedCallback() {
          document.removeEventListener('nuance:wishlist-change', this.syncWish);
        }

        setStatus(text) {
          if (this.status) this.status.textContent = text;
        }

        async add(variantId) {
          if (this.classList.contains('is-adding')) return;
          this.classList.add('is-adding');
          this.setStatus('Adding…');

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const routes = (window.Theme && window.Theme.routes) || {};
          const addUrl = (routes.cart_add_url || root + 'cart/add').replace(/\.js$/, '');
          const cartUrl = (routes.cart_url || root + 'cart').replace(/\.js$/, '');

          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          // Tell Horizon a line is being added so the cart drawer and bubble update
          let events = null;
          let deferred = null;
          try {
            events = await import('@shopify/events');
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
          } catch (e) {
            events = null;
            deferred = null;
          }

          const getCart = () =>
            fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

          try {
            const response = await fetch(addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const data = await response.json();

            if (data.status) {
              if (deferred) {
                getCart()
                  .then((cart) =>
                    deferred.resolve({
                      cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                      detail: { didError: true, items: cart.items, source: 'nuance-card', itemCount: 1, productId: this.dataset.productId },
                    })
                  )
                  .catch((err) => deferred.reject(err));
              }
              throw new Error(data.description || data.message || 'Could not add to bag');
            }

            if (!deferred) {
              window.location.href = cartUrl;
              return;
            }

            const cart = await getCart();
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'nuance-card',
                itemCount: 1,
                productId: this.dataset.productId,
                sections: data.sections,
                didError: false,
              },
            });
            this.setStatus('Added to bag');
          } catch (error) {
            this.setStatus(error && error.message ? error.message : 'Could not add to bag');
          } finally {
            this.classList.remove('is-adding');
            clearTimeout(this.statusTimer);
            this.statusTimer = setTimeout(() => this.setStatus(''), 2500);
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuance-upsell-tap"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nuanceUpsellBound) return;
    window.__nuanceUpsellBound = true;

    var last = 0;

    function component(node) {
      var el = node.closest('nuance-cart-upsell');
      return el && typeof el.go === 'function' ? el : null;
    }

    /* Drives the strip directly if the element is somehow still missing. Sliding is
       presentation only, so doing it here is safe. Adding is not, and is never done here. */
    function slide(node, direction) {
      var el = component(node);
      if (el) {
        el.go(direction);
        return;
      }
      var root = node.closest('.ncu');
      var track = root && root.querySelector('[data-ncu-track]');
      if (!track) return;
      var count = track.children.length;
      if (count < 2) return;
      var current = parseInt(track.getAttribute('data-ncu-index') || '0', 10);
      var next = (current + direction + count) % count;
      track.setAttribute('data-ncu-index', next);
      track.style.transform = 'translateX(' + -next * 100 + '%)';
    }

    function originOf(event) {
      if (event.type === 'touchend') {
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return null;
        return document.elementFromPoint(touch.clientX, touch.clientY);
      }
      return event.target;
    }

    function handle(event) {
      var origin = originOf(event);
      if (!origin || !origin.closest) return;

      var prev = origin.closest('[data-ncu-prev]');
      var next = origin.closest('[data-ncu-next]');
      var add = origin.closest('[data-ncu-add]');
      if (!prev && !next && !add) return;

      var now = Date.now();
      if (now - last < 400) {
        event.stopPropagation();
        return;
      }
      last = now;

      event.stopPropagation();

      if (prev) {
        slide(prev, -1);
        return;
      }
      if (next) {
        slide(next, 1);
        return;
      }

      var el = component(add);
      if (!el) return;
      if (event.cancelable) event.preventDefault();
      el.add(add);
    }

    document.addEventListener('click', handle, true);
    document.addEventListener('pointerup', handle, true);
    document.addEventListener('touchend', handle, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuance-wishlist-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuance-wish-drawer')) {
    const KEY = 'nuance:wishlist';

    const readList = () => {
      try {
        const list = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };

    const writeList = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('nuance:wishlist-change', { detail: { list } }));
    };

    customElements.define(
      'nuance-wish-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.listEl = this.querySelector('[data-list]');
          this.emptyEl = this.querySelector('[data-empty]');
          this.loadingEl = this.querySelector('[data-loading]');
          this.root = this.dataset.root || '/';
          if (!this.root.endsWith('/')) this.root += '/';
          this.loaded = false;

          this.countEl = this.querySelector('[data-count]');
          this.updateCount = () => {
            if (!this.countEl) return;
            const count = readList().length;
            this.countEl.textContent = count > 99 ? '99+' : String(count);
            this.countEl.classList.toggle('visually-hidden', count === 0);
          };
          this.updateCount();

          this.onChange = () => {
            this.updateCount();
            if (this.loaded) this.refresh();
          };
          document.addEventListener('nuance:wishlist-change', this.onChange);

          this.addEventListener('click', (event) => {
            const remove = event.target.closest('[data-remove]');
            const toggle = event.target.closest('[data-sizes-toggle]');
            const variantButton = event.target.closest('[data-variant-id]');
            if (!remove && !toggle && !variantButton) return;

            // Keep the click inside the drawer: removing the item from the DOM
            // must not be read as a click outside, which would close the drawer.
            event.preventDefault();
            event.stopPropagation();

            const item = event.target.closest('.nwd-item');

            if (remove) {
              // THE HANDLE COMES FROM THE <li>, NEVER FROM THE CARD INSIDE IT.
              //
              // Both carry data-handle, and closest('[data-handle]') finds the card
              // first. That reads the same value only while the product still answers
              // to the handle the list stored. Rename a product and it no longer does:
              // /products/<old-handle> 301s to the new one, the card comes back carrying
              // the NEW handle, and filtering the list on it removes nothing, because the
              // list still holds the old one. The item then cannot be deleted at all —
              // every click writes the list back unchanged.
              //
              // The <li> is created here, from the stored handle, so its data-handle is
              // the only one guaranteed to match what readList() returns.
              const li = Array.from(this.listEl.children).find((el) => el.contains(remove));
              const handle = li && li.dataset.handle;
              if (!handle) return;
              requestAnimationFrame(() => writeList(readList().filter((h) => h !== handle)));
              return;
            }

            if (toggle) {
              const sizes = item?.querySelector('[data-sizes]');
              if (!sizes) return;
              const open = sizes.hasAttribute('hidden');
              sizes.toggleAttribute('hidden', !open);
              item.classList.toggle('is-picking', open);
              toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
              return;
            }

            if (variantButton && item) this.addToBag(item, variantButton.dataset.variantId);
          });
        }

        async addToBag(item, variantId) {
          if (item.classList.contains('is-adding')) return;
          const status = item.querySelector('[data-status]');
          const setStatus = (text) => {
            if (status) status.textContent = text;
            item.classList.toggle('has-status', Boolean(text));
          };
          item.classList.add('is-adding');
          setStatus('Adding…');

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const routes = (window.Theme && window.Theme.routes) || {};
          const addUrl = (routes.cart_add_url || root + 'cart/add').replace(/\\.js$/, '');
          const cartUrl = (routes.cart_url || root + 'cart').replace(/\\.js$/, '');

          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          let events = null;
          let deferred = null;
          try {
            events = await import('@shopify/events');
            deferred = events.CartLinesUpdateEvent.createPromise();
            item.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
          } catch (e) {
            events = null;
            deferred = null;
          }

          const getCart = () =>
            fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

          try {
            const response = await fetch(addUrl + '.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const data = await response.json();

            if (data.status) {
              if (deferred) {
                getCart()
                  .then((cart) =>
                    deferred.resolve({
                      cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                      detail: { didError: true, items: cart.items, source: 'nuance-wishlist', itemCount: 1, productId: item.dataset.productId },
                    })
                  )
                  .catch((err) => deferred.reject(err));
              }
              throw new Error(data.description || data.message || 'Could not add to bag');
            }

            if (deferred) {
              const cart = await getCart();
              deferred.resolve({
                cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items,
                  source: 'nuance-wishlist',
                  itemCount: 1,
                  productId: item.dataset.productId,
                  sections: data.sections,
                  didError: false,
                },
              });
            }

            setStatus('Added to bag');
            const sizes = item.querySelector('[data-sizes]');
            const toggle = item.querySelector('[data-sizes-toggle]');
            if (sizes) sizes.setAttribute('hidden', '');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
            item.classList.remove('is-picking');
          } catch (error) {
            setStatus(error && error.message ? error.message : 'Could not add to bag');
          } finally {
            item.classList.remove('is-adding');
            clearTimeout(item._statusTimer);
            item._statusTimer = setTimeout(() => setStatus(''), 2500);
          }
        }

        disconnectedCallback() {
          document.removeEventListener('nuance:wishlist-change', this.onChange);
        }

        itemFor(handle) {
          return Array.from(this.listEl.children).find((li) => li.dataset.handle === handle);
        }

        async refresh() {
          this.loaded = true;
          const list = readList();

          Array.from(this.listEl.children).forEach((li) => {
            if (!list.includes(li.dataset.handle)) li.remove();
          });

          const missing = list.filter((handle) => !this.itemFor(handle));
          if (missing.length) {
            if (!this.listEl.children.length) this.loadingEl.hidden = false;
            this.emptyEl.hidden = true;

            const results = await Promise.all(
              missing.map(async (handle) => {
                try {
                  const response = await fetch(this.root + 'products/' + encodeURIComponent(handle) + '?view=nuance-wish-item');
                  if (!response.ok) return { handle, html: null };
                  return { handle, html: (await response.text()).trim() };
                } catch (e) {
                  return { handle, html: '' };
                }
              })
            );

            results.forEach((r) => {
              if (!r.html || this.itemFor(r.handle)) return;
              const li = document.createElement('li');
              li.dataset.handle = r.handle;
              li.innerHTML = r.html;
              this.listEl.appendChild(li);
            });

            const gone = results.filter((r) => r.html === null).map((r) => r.handle);
            if (gone.length) {
              writeList(readList().filter((h) => !gone.includes(h)));
              return;
            }
          }

          // Newest first
          readList()
            .slice()
            .reverse()
            .forEach((handle) => {
              const li = this.itemFor(handle);
              if (li) this.listEl.appendChild(li);
            });

          this.loadingEl.hidden = true;
          this.emptyEl.hidden = this.listEl.children.length > 0;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
